module.exports = __webpack_public_path__ + "img/logo_wcaworld2.7c5edc9a.png";